import { render, staticRenderFns } from "./chat-header.vue?vue&type=template&id=13ff57c3&scoped=true"
import script from "./chat-header.vue?vue&type=script&lang=js"
export * from "./chat-header.vue?vue&type=script&lang=js"
import style0 from "./chat-header.vue?vue&type=style&index=0&id=13ff57c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ff57c3",
  null
  
)

export default component.exports